import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {SettingsService} from '../settings.service';
import {Processo} from '../comum/modelos/processo';
import {ProcessoCliente} from '../comum/modelos/processo-cliente';
import {ProcessoSetor} from '../comum/modelos/processo-setor';
import { SetorCliente } from '../comum/modelos/setor-cliente';
import {SetorPontoFisico} from '../comum/modelos/setor-ponto-fisico';
import {HttpResponse, HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ProcessoService {

  private _host: string;


  constructor(
    private _settingsService: SettingsService,
    private _http: HttpClient) {
    this._host = this._settingsService.obterHostBase() + '/processos/';
  }

  obterProcessosHttp(): Observable<Processo[]> {
    return this._http.get(this._host)
      .catch(this.handleError);
  }

    removerProcessoHttp(idProcesso: number): Observable<HttpResponse<Processo>> {
        return this._http.delete(this._host + idProcesso, {
            observe: 'response'
        }).catch(this.handleError);
    }

  cadastrarProcessoHttp(processo: Processo): Observable<HttpResponse<Processo>> {
    return this._http
      .post(this._host, processo, {
        observe: 'response'
      }).catch(this.handleError);
  }

  atualizarProcessoHttp(processo: Processo): Observable<HttpResponse<Processo>> {
    return this._http
      .put(this._host, processo, {
        observe: 'response'
      }).catch(this.handleError);
  }

  obterProcessoPorIdHttp(id: number): Observable<Processo> {
    return this._http.get(this._host + id)
      .catch(this.handleError);
  }

  obterProcessosClienteHttp(id: number): Observable<ProcessoCliente[]> {
    return this._http.get(this._host + 'cliente/' + id)
      .catch(this.handleError);
  }

  obterProcessosClienteFromSetoresHttp(setores: SetorCliente[]): Observable<ProcessoCliente[]> {
    const params = new URLSearchParams();
    let ids: string;

    for (let i = 0, len = setores.length; i < len; i++) {
      if (i === 0) {
        ids = '?id=' + setores[i].idSetorCliente;
      } else {
        ids = ids + '&id=' + setores[i].idSetorCliente;
      }
    }

    params.append('ids', ids.toString());
    return this._http.get(this._host + '/cliente/setor/' + ids)
      .catch(this.handleError);
  }

  cadastrarProcessosClienteHttp(processosCliente: ProcessoCliente[]): Observable<HttpResponse<ProcessoCliente[]>> {
    return this._http
      .post(this._host + 'cliente/', processosCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerProcessosClienteHttp(processosCliente: ProcessoCliente[]): Observable<HttpResponse<ProcessoCliente[]>> {
    return this._http
      .patch(this._host + 'cliente/', processosCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterProcessosSetoresHttp(setores: SetorPontoFisico[]): Observable<ProcessoSetor[]> {
    const params = new URLSearchParams();
    let ids: string;

    for (let i = 0, len = setores.length; i < len; i++) {
      if (i === 0) {
        ids = '?id=' + setores[i].idSetorPontoFisico;
      } else {
        ids = ids + '&id=' + setores[i].idSetorPontoFisico;
      }
    }

    params.append('ids', ids.toString());
    return this._http.get(this._host + 'setor/' + ids)
      .catch(this.handleError);
  }

  obterProcessosSetoresClienteHttp(setores: SetorCliente[]): Observable<ProcessoSetor[]> {
    const params = new URLSearchParams();
    let ids: string;

    for (let i = 0, len = setores.length; i < len; i++) {
      if (i === 0) {
        ids = '?id=' + setores[i].idSetorCliente;
      } else {
        ids = ids + '&id=' + setores[i].idSetorCliente;
      }
    }

    params.append('ids', ids.toString());
    return this._http.get(this._host + 'setor-cliente/' + ids)
      .catch(this.handleError);
  }

  obterProcessosSetorHttp(idSetorPontoFisico: number): Observable<ProcessoSetor[]> {
    return this._http.get(this._host + 'setor/' + idSetorPontoFisico)
      .catch(this.handleError);
  }

  obterProcessoSetorHttp(idProcessoSetor: number): Observable<ProcessoSetor> {
    return this._http.get(this._host + 'processo-setor/' + idProcessoSetor)
      .catch(this.handleError);
  }

  obterProcessosSetorClienteHttp(idCliente: number): Observable<ProcessoSetor[]> {
    return this._http.get(this._host + 'setor/cliente/' + idCliente)
      .catch(this.handleError);
  }

  cadastrarProcessosSetorHttp(processosSetor: ProcessoSetor[]): Observable<HttpResponse<ProcessoSetor[]>> {
    return this._http
      .post(this._host + 'setor/', processosSetor, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerProcessosSetorHttp(processosSetor: ProcessoSetor[]): Observable<HttpResponse<ProcessoSetor[]>> {
    return this._http
      .patch(this._host + 'setor/', processosSetor, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterProcessosFromSetoresPontoFisicoHttp(setores: SetorPontoFisico[]): Observable<Processo[]> {
    const params = new URLSearchParams();
    let ids: string;

    for (let i = 0, len = setores.length; i < len; i++) {
      if (i === 0) {
        ids = '?id=' + setores[i].idSetorPontoFisico;
      } else {
        ids = ids + '&id=' + setores[i].idSetorPontoFisico;
      }
    }

    params.append('ids', ids.toString());
    return this._http.get(this._host + 'processo-from-setor_ponto-fisico/' + ids)
      .catch(this.handleError);
  }

  private handleError(error: Response) {

    console.error(error);

    return Observable.throw(error.json().error || 'Server error');

  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/processo/processo.service.ts